/* Native scroll; one lifecycle per section, including Shopify editor reloads. */
if (!customElements.get('fdl-photo-edit')) {
  customElements.define('fdl-photo-edit', class extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-fashion-scroll]');
      this.thumb = this.querySelector('[data-fashion-thumb]');
      if (!this.scroller || !this.thumb) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateProgress());
      };
      this.scroller.addEventListener('scroll', update, { ...options, passive: true });
      window.addEventListener('resize', update, options);
      this.scroller.addEventListener('keydown', event => {
        if (event.target !== this.scroller) return;
        const card = this.scroller.querySelector('.fashion-secao__card');
        if (!card || this.scroller.scrollWidth <= this.scroller.clientWidth) return;
        const stride = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.scroller).columnGap) || 0);
        const positions = { ArrowRight: this.scroller.scrollLeft + stride, ArrowLeft: this.scroller.scrollLeft - stride, Home: 0, End: this.scroller.scrollWidth };
        if (!(event.key in positions)) return;
        event.preventDefault();
        this.scroller.scrollTo({ left: positions[event.key], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.fashion-secao__card');
        if (!card || this.scroller.scrollWidth <= this.scroller.clientWidth) return;
        const left = card.getBoundingClientRect().left - this.scroller.getBoundingClientRect().left + this.scroller.scrollLeft;
        this.scroller.scrollTo({ left: left - this.scroller.clientWidth / 2 + card.clientWidth / 2, behavior: 'auto' });
      }, options);
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(this.scroller);
      for (const card of this.scroller.children) this.resizeObserver.observe(card);
      update();
    }
    updateProgress() {
      const max = this.scroller.scrollWidth - this.scroller.clientWidth;
      const track = this.thumb.parentElement;
      track.hidden = max <= 1;
      const progress = max > 0 ? Math.max(0, Math.min(1, this.scroller.scrollLeft / max)) : 0;
      this.thumb.style.transform = `translateX(${progress * (track.clientWidth - this.thumb.offsetWidth)}px)`;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
